import { Box } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
    const navigate = useNavigate();

    return (
        <Box textAlign="center" py={10} px={6}>
            <section class="page_404">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12 ">
                            <div class="col-sm-10 col-sm-offset-1  text-center">
                                <h1 class="text-center">4oh4</h1>
                                <div style={{
                                    backgroundImage: `url(${process.env.REACT_APP_APP_URL}/404.gif )`,
                                }} className="four_zero_four_bg">

                                </div>

                                <div class="contant_box_404">
                                    <h3 class="h2">
                                        Look like you're lost
                                    </h3>

                                    <p>the page you are looking for not avaible!</p>

                                    <a href="/" class="link_404">Go to Home</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Box>
    );
};

export default NotFoundPage;
